import {ReactComponent as HomeIcon} from '../../../images/icons/General/home-line.svg';
import {ReactComponent as LayersIcon} from '../../../images/icons/Layout/layers-three-01.svg';
import {ReactComponent as LayersIcon2} from '../../../images/icons/Layout/layout-alt-03.svg';
import {ReactComponent as FolderIcon} from '../../../images/icons/Files/file-02.svg';
import {ReactComponent as FileIcon} from '../../../images/icons/Files/file-05.svg';
import {ReactComponent as DefaultFolderIcon} from '../../../images/icons/Files/folder.svg';
import {ReactComponent as WavesIcon} from '../../../images/icons/Weather/waves.svg';
import {ReactComponent as ListIcon} from '../../../images/icons/Layout/list.svg';
import {ReactComponent as AlertIcon} from '../../../images/icons/Alerts/alert-triangle.svg';
import {ReactComponent as ChartIcon} from '../../../images/icons/Charts/pie-chart-03.svg';
import {ReactComponent as UsersIcon} from '../../../images/icons/Users/users-01.svg';
import {ReactComponent as MesIcon} from '../../../images/icons/Communication/message-question-circle.svg';
import {ReactComponent as UserIcon} from '../../../images/icons/Users/user-01.svg';
import {ReactComponent as UsersCheckIcon} from '../../../images/icons/Users/users-check.svg';
import {ReactComponent as Users3Icon} from '../../../images/icons/Users/users-03.svg';
import {ReactComponent as TargetIcon} from '../../../images/icons/General/target-04.svg';
import {ReactComponent as GlobeIcon} from '../../../images/icons/Maps/globe-06.svg';
import {ReactComponent as UsersRightIcon} from '../../../images/icons/Users/users-right.svg';
import {ReactComponent as CalendarIcon} from '../../../images/icons/Time/calendar-minus-01.svg';
import {ReactComponent as Chart1Icon} from '../../../images/icons/Charts/bar-chart-07.svg';
import {ReactComponent as Chart2Icon} from '../../../images/icons/Charts/bar-chart-square-02.svg';
import {ReactComponent as Chart3Icon} from '../../../images/icons/Charts/bar-chart-square-01.svg';
import {ReactComponent as UploadIcon} from '../../../images/icons/General/upload-cloud-02.svg';
import {ReactComponent as AnnotationAlert} from '../../../images/icons/Communication/annotation-alert.svg';
import {ReactComponent as HandIcon} from '../../../images/icons/Editor/hand.svg';
import {ReactComponent as MailIcon} from '../../../images/icons/Communication/mail-01.svg';
import {ReactComponent as BookmarkIcon} from '../../../images/icons/General/bookmark-check.svg';
import {ReactComponent as SpeedometerIcon} from '../../../images/icons/General/speedometer-02.svg';
import {ReactComponent as OctagonIcon} from '../../../images/icons/General/info-octagon.svg';
import {ReactComponent as BuoyIcon} from '../../../images/icons/General/life-buoy-01.svg';
import {ReactComponent as UserCheckIcon} from '../../../images/icons/Users/user-check-01.svg';
import {ReactComponent as DiveModeIcon} from '../../../images/icons/General/speedometer-03.svg';
import {ReactComponent as SettingsIcon} from '../../../images/icons/General/settings-03.svg';

export const iconMap = {
    HomeIcon,
    LayersIcon,
    LayersIcon2,
    FolderIcon,
    WavesIcon,
    ListIcon,
    AlertIcon,
    ChartIcon,
    UsersIcon,
    MesIcon,
    UserIcon,
    UsersCheckIcon,
    Users3Icon,
    TargetIcon,
    GlobeIcon,
    UsersRightIcon,
    CalendarIcon,
    Chart1Icon,
    Chart2Icon,
    Chart3Icon,
    UploadIcon,
    AnnotationAlert,
    HandIcon,
    FileIcon,
    DefaultFolderIcon,
    MailIcon,
    BookmarkIcon,
    SpeedometerIcon,
    OctagonIcon,
    BuoyIcon,
    UserCheckIcon,
    DiveModeIcon,
    SettingsIcon
};
